import styled from "styled-components";

export const TableWrapper = styled.div`
  margin: 35px 16px;
`